/** Takvim bos slotlari: baslangictan 1 dk sonra rezervasyon kapali. Europe/Istanbul. */

export function getIstanbulTodayYmd(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Istanbul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

export function istanbulNowMinutes(): number {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Istanbul",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(new Date());
  const hour = Number(parts.find((p) => p.type === "hour")?.value);
  const minute = Number(parts.find((p) => p.type === "minute")?.value);
  if (Number.isNaN(hour) || Number.isNaN(minute)) return 0;
  return hour * 60 + minute;
}

export function parseTimeToMinutes(hhmm: string): number {
  const [h, m] = hhmm.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return -1;
  return h * 60 + m;
}

/** Bos slot icin rezervasyon suresi doldu mu (backend slots-day-grid ile uyumlu). */
export function isEmptySlotPastBookingDeadline(slotDateYmd: string, slotStart: string): boolean {
  const today = getIstanbulTodayYmd();
  if (slotDateYmd < today) return true;
  if (slotDateYmd > today) return false;
  const slotStartMin = parseTimeToMinutes(slotStart);
  if (slotStartMin < 0) return false;
  return slotStartMin + 1 <= istanbulNowMinutes();
}
